<template>
  <div id="crew-labor-detail">
    <!-- vx-card表示領域 -->
    <div class="vx-card crew-labor-detail-card vs-con-loading__container">
      <!-- 一覧タブ切替え領域 -->
      <!-- タブのヘッダー -->
      <div class="card-top-tab-area flex items-center">
        <ul class="tabs">
          <li
            v-for="(tab, index) in tabInfo"
            :key="tab.dom_id"
            :class="{ active: index === activeTab }"
            class="flex justify-center items-center"
            @click="jumpFromTab(index)"
          >
            <img :src="getIconFromIconMap(tab.icon)" />
            <span class="material-icons-outlined text-xl">{{ tab.icon }}</span>
            <span class="ml-2 whitespace-no-wrap aisea-text-16-400-dark-gray">{{
              tab.title
            }}</span>
          </li>
        </ul>
      </div>
      <div
        class="p-6 pt-2 h-full uk-position-relative crew-labor-detail-tab-area"
      >
        <!-- v-if による弊害が起きないか検証 -->
        <div v-if="activeTab === 0" class="w-full h-full">
          <!-- 勤怠情報 RE-1 領域 -->
          <monthly-labor-record
            :enterpriseVesselId="$route.params.id"
            :key="enterpriseVesselId"
            :active="activeTab === 0"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MonthlyLaborRecord from "./tabs/MonthlyLaborRecord.vue";

import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import _ from "lodash";

import { createNamespacedHelpers } from "vuex";
const { mapActions, mapState } = createNamespacedHelpers("crewAccount");

export default {
  components: {
    MonthlyLaborRecord,
  },
  mixins: [DeviceInfoMixin, ColorMixin],
  data() {
    return {
      // タブで切り替え可能な画面の情報
      tabInfo: [
        {
          dom_id: "tab-labor-0",
          title: "勤怠情報",
          routeName: "enterprise-management-crew-operator-crew-labor-detail",
          icon: "today",
        },
      ],

      activeTab: 0,
    };
  },
  computed: {
    ...mapState({
      crewAccount: state => state.crewAccount,
      crewList: state => state.crewList,
    }),
    queryTab() {
      return this.$route.query.tab;
    },
    enterpriseVesselId() {
      //   if (this.$route.meta.dispType === "labor") {
      return this.$route.params.id;
      //   } else {
      //     return null;
      //  }
    },
  },
  watch: {
    "$route.name"() {
      this.activeTab = isNaN(this.$route.meta.tabNumber)
        ? 0
        : Number(this.$route.meta.tabNumber);
    },
  },
  methods: {
    ...mapActions([
      "setCrewAccount",
      "clearCrewAccount",
      "setCrewList",
      "getAlertList",
    ]),
    getIconFromIconMap(key) {
      // this.iconMapにkeyのキーがあるかどうか確認する
      if (_.has(this.iconMap, key)) {
        return this.iconMap[key];
      } else {
        null;
      }
    },

    jumpFromTab(tabNumber) {
      const linkToObj = this.tabInfo[tabNumber].routeName;
      if (this.$route.name !== linkToObj.routeName) {
        this.$router.push({ name: linkToObj }, () => {});
      }
    },
    loadingStart() {
      this.$vs.loading({
        container: "#crew-labor-detail",
        color: this.AISEA_COLOR.BLUE,
        background: "rgba(255, 255, 255, 0.4)",
      });
    },
    loadingClose: _.debounce(async self => {
      self.$vs.loading.close("#crew-labor-detail > .con-vs-loading");
    }, 800),
  },
  mounted() {
    if (this.isRouteCrewStatusList) {
      this.checkAlert().then(() => {
        this.$nextTick(() => {
          this.resizeCrewStatusList();
        });
      });
      return;
    }
    let routerViewElement = document.getElementsByClassName("router-view");
    routerViewElement[0].style.padding = "2.2rem";
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
#crew-labor-detail {
  font-family: $aisea-font-family;
  color: $aisea-black;

  .tabs {
    list-style-type: none;
    padding: 0;
    display: flex;
    overflow-x: scroll;

    /*スクロールバー非表示（IE・Edge）*/
    -ms-overflow-style: none;
    /*スクロールバー非表示（Firefox）*/
    scrollbar-width: none;
    color: $aisea-dark-gray;
  }

  .tabs li {
    padding: 10px 20px;
    cursor: pointer;
    border-right: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    transition: background-color 0.2s ease-in-out;
    font-size: 16px;
  }
  .tabs li:hover:not(.active) {
    background-color: #e1e1e1;
  }

  .tabs li.active {
    cursor: default;
    border-bottom: none;
    border-top: $aisea-blue solid 3px;
    span {
      font-weight: bold;
    }
  }

  .crew-labor-detail-card {
    margin-top: 1rem;
  }

  .increment-user-button {
    :hover {
      border-radius: 4px;
      background-color: $aisea-white;
    }
  }

  .retirement-badge {
    font-size: 12px;
    color: $aisea-dark-gray;
    background-color: $aisea-white;
    border-radius: 4px;
    padding: 2px 4px;
  }
}
#custom-breadcrumb-title {
  display: flex;
  align-items: center;
  position: absolute;
  padding: 0;
  margin: 0;
}
</style>
